import { createApi } from "@reduxjs/toolkit/query/react";
import baseQueryWithReauth from "./BaseQuery";

export const exportRuleApi = createApi({
  reducerPath: "exportRuleApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["export-rules"],
  endpoints: (builder) => ({
    createExportRule: builder.mutation({
      query: (payload) => ({
        url: "export-rules",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["export-rules"]
    }),
    getExportRules: builder.query({
      query: () => ({
        url: `export-rules`,
        method: "GET",
      }),
      providesTags: ["export-rules"]
    }),
    getStaffUsers: builder.query({
      query: () => ({ url: "staff-export-assign", method: "GET" }),
    }),
    // ✅ GET SINGLE (for Edit page)
    getExportRuleById: builder.query({
      query: (id: string) => ({
        url: `export-rules/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [
        { type: "export-rules", id },
      ],
    }),
     // ✅ UPDATE
     updateExportRule: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `export-rules/${id}`,
        method: "PUT", 
        body: payload,
      }),
      invalidatesTags: ["export-rules"],
    }),
    // Delete rule
     deleteExportRule: builder.mutation({
      query: (id) => ({
        url: `export-rules/${id}`,
        method: "DELETE", 
      }),
      invalidatesTags: ["export-rules"],
    }),
  }),
});

export const { useCreateExportRuleMutation, useGetExportRulesQuery, useGetStaffUsersQuery, useGetExportRuleByIdQuery, useUpdateExportRuleMutation, useDeleteExportRuleMutation } = exportRuleApi;